/**
 * PTW Template Library Favourites (Task #2796)
 *
 * Per-user favourites for the template library. A user can star any published
 * library entry; starred entries appear when the "Favourites" filter is active
 * on the /ptw/library page.
 *
 * Do NOT edit existing shared schema files to add content here.
 */

import { sql } from "drizzle-orm";
import {
  pgTable,
  uuid,
  text,
  timestamp,
  uniqueIndex,
  index,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

export const ptwLibraryFavourites = pgTable(
  "ptw_library_favourites",
  {
    id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
    tenantId: text("tenant_id").notNull(),
    userId: text("user_id").notNull(),
    libraryEntrySlug: text("library_entry_slug").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  },
  (t) => ({
    idxFavUnique: uniqueIndex("idx_ptw_library_favourites_unique").on(t.userId, t.libraryEntrySlug),
    idxFavTenant: index("idx_ptw_library_favourites_tenant_id").on(t.tenantId),
    idxFavUser: index("idx_ptw_library_favourites_user_id").on(t.userId),
    idxFavSlug: index("idx_ptw_library_favourites_slug").on(t.libraryEntrySlug),
  }),
);

export type PtwLibraryFavourite = typeof ptwLibraryFavourites.$inferSelect;

export const insertPtwLibraryFavouriteSchema = createInsertSchema(ptwLibraryFavourites).omit({
  id: true,
  createdAt: true,
});
export type PtwLibraryFavouriteInsert = z.infer<typeof insertPtwLibraryFavouriteSchema>;
